<template><svg width="549px" height="540px" viewBox="0 0 549 540" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="dot" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <ellipse id="Oval" fill="#767676" cx="274.5" cy="270" rx="173" ry="181"></ellipse>
    </g>
</svg></template>